<div id="popup_container">

  <div id="popup_titleContainer">
    <div id="titleIcon_container" class="flex justify-center items-center
                                    w-10 h-10
                                    rounded-full">
      <mat-icon class="material-icons-outlined" [svgIcon]="getLeftIcon()"></mat-icon>
    </div>
    <p id="popup_title">{{ isOfPanelClass(panelClasses.ALERT) ?
      ('ERROR_POPUP.ERROR_DETAILS' | translate) :
      isOfPanelClass(panelClasses.INFO) ?
      ('INFO_POPUP.INFO_DETAILS' | translate) :
      isOfPanelClass(panelClasses.WARNING) ?
      ('WARNING_POPUP.WARNING_DETAILS' | translate) :
      isOfPanelClass(panelClasses.SUCCESS) ?
      ('SUCCESS_POPUP.SUCCESS_DETAILS' | translate) : '' }}
    </p>
  </div>

  @if (data.messages) {
    <mat-dialog-content id="popup_content"
      class="mat-typography">
      @if (data.messages && data.messages.length > 1) {
        @if (isOfPanelClass(panelClasses.ALERT)) {
          <p id="popup_info">
            {{('ERROR_POPUP.MULTIPLE_ERRORS' | translate:{ amount: data.messages.length })}}
          </p>
        }
        <div id="popup_detailsContainer">
          <ul>
            @for (message of data.messages; track message) {
              <li class="popup_message"
              [innerHTML]="message | linebreak"></li>
            }
          </ul>
        </div>
      }
      @if (data.messages && data.messages.length === 1) {
        <span class="popup_message"
        [innerHTML]="(data.messages.join()) | linebreak"></span>
      }
    </mat-dialog-content>
  }

  <mat-dialog-actions id="popup_actionBar">
    <button mat-stroked-button (click)="copyToClipboard()"
      class="clipBoardButton"
      onclick="blur()"
      color="primary">
      <mat-icon svgIcon="content_copy"></mat-icon>
      Copy to clipboard
    </button>
    <div class="flex-grow"></div>
    <button mat-flat-button
      id="popup_okButton"
      tabindex="-1"
      mat-dialog-close>{{'DONE' | translate}}
    </button>
  </mat-dialog-actions>

</div>
